import * as React from "react";

export interface IDragSortProps {
    children: any[];
    data: any[];
    onReOrder: (result: any[]) => void;
    onDragStyle?: CSSStyleDeclaration;
    disableDrag?: boolean;
}

export const DragSort = (props: IDragSortProps) => {
    if (!props.children) {return null;}

    const [items, setItems] = React.useState(props.children);

    React.useEffect(() => {
        setItems(props.children);
    }, [props.children]);

    const getList = () => document.getElementById("drag-sort-items");

    const move = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();

        const list = e.currentTarget.parentNode,
            x = e.clientX,
            y = e.clientY;

        const swapItem = document.elementFromPoint(x, y) === null ? e.currentTarget : document.elementFromPoint(x, y);

        if (list === swapItem.parentNode) {
            const _swapItem = swapItem !== e.currentTarget.nextSibling ? swapItem : swapItem.nextSibling;
            list.insertBefore(e.currentTarget, _swapItem);
        }
        if (list.contains(swapItem) && list !== swapItem) {
            const dragItem = getDragItemByTarget(swapItem, list);
            const _swapItem = dragItem && dragItem !== e.currentTarget.nextSibling ? dragItem : swapItem.nextSibling;
            list.insertBefore(e.currentTarget, _swapItem);
        }
    };

    const getDragItemByTarget = (target: Element, pNode: Node) => {
        let _dragItem = null;
        pNode.childNodes.forEach((item) => {
            if (item.contains(target)) {
                _dragItem = item;
            }
        });
        return _dragItem;
    };

    const drop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        (e.currentTarget.childNodes[0] as HTMLElement).style.opacity = "1";
        const _list = getList();
        const result = [];
        _list.childNodes.forEach((element) => {
            const index = (element as HTMLElement).id;
            result.push(props.data[index]);
        });

        props.onReOrder(result);
    };

    const getChildren = items.map((item, key) => {
        return (
            <div
                id={key.toString()}
                draggable={!props.disableDrag}
                onDragStart={(e: React.DragEvent<HTMLDivElement>) => {
                    (e.currentTarget.childNodes[0] as HTMLElement).style.opacity = "0.2";
                }}
                style={{ userSelect: "none" }}
                onDrag={(e) => move(e)}
                onDrop={(e) => {
                    e.preventDefault();
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                }}
                onDragEnd={(e) => drop(e)}
            >
                {item}
            </div>
        );
    });

    return <div id="drag-sort-items">{getChildren}</div>;
};
